<template>

	<iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey">
		<template #rightContent>
			<div class="interlock-settings">
				<div v-if="storeInfo" class="text-left">
					<div class="title" style="position:relative;">
						<span>连锁设置</span>
					</div>
					<div class="content">
						<van-row type="flex">
							<van-col span="3">
								<span class="name">机构名称：</span>
							</van-col>
							<van-col span="16">
								<div class="info">{{storeInfo.StoreName}}</div>
							</van-col>
						</van-row>
						<van-row type="flex">
							<van-col span="3">
								<span class="name">门店地址：</span>
							</van-col>
							<van-col span="16">
								<div class="info">{{storeInfo.Address}}</div>
							</van-col>
						</van-row>
						<van-row type="flex">
							<van-col span="3">
								<span class="name">联系人姓名：</span>
							</van-col>
							<van-col span="16">
								<div class="info">{{storeInfo.LinkMan}}</div>
							</van-col>
						</van-row>
						<van-row type="flex">
							<van-col span="3">
								<span class="name">联系人电话：</span>
							</van-col>
							<van-col span="16">
								<div class="info">{{storeInfo.LinkTel}}</div>
							</van-col>
						</van-row>
						<van-row type="flex">
							<van-col span="3">
								<span class="name">纳税人识别号：</span>
							</van-col>
							<van-col span="16">
								<div class="info">{{storeInfo.TaxNumber}}</div>
							</van-col>
						</van-row>
					</div>
					<el-button type="primary" class="sub-btn" style="margin-top: 48px;width: 136px;" @click="()=>{
						show_bind = true
					}">更换</el-button>
				</div>
				<div v-else class="text-left no-store">
					<div class="title" style="position:relative;">
						<span>连锁设置</span>
						<span class="danger_color">
							<i class="el-icon-warning-outline"></i> 非连锁机构请勿设置!
						</span>

					</div>
					<div class="mian-word">
						<span class="">连锁设置适用于连锁机构，如下场景时：</span>
					</div>
					<div class="tips-box">
						<h5>1.当分店采购，货要寄到总店</h5>
						<h5>2.当分店采购，发票和出库单需要开总店</h5>
						<div class="tips-last">添加时请谨慎核对，避免添加错误，否者会造成无法入库的问题。</div>

					</div>
					<div class="example">
						<div class="example-title">设置成功后，在订单支付页面，可选择收货地址和出库单发票主体。如下图所示</div>
						<el-row :gutter="24">
							<el-col :span="12">
								<img src="../../assets/chainstore/issuingoffice.png">
							</el-col>
							<el-col :span="12">
								<img src="../../assets/chainstore/address.png">
							</el-col>
						</el-row>
					</div>
					<div class="text-left">
						<el-button type="primary" class="sub-btn" @click.stop="()=>{
							show_bind = true
						}">+ 绑定总店</el-button>
					</div>

				</div>

				<a-modal v-model="show_bind" centered :footer="null" :closable="false" :maskClosable="false"
					width="574px" :bodyStyle="{ padding: 0 }">
					<div class="flex-invoice-box">
						<div class="flex-invoice-header">
							选择门店
							<img class="image-close" src="../../assets/buycar/model-close.png"
								@click="closeModel()" />
						</div>
						<div class="bind-box">
							<div class="no-tips">
								<i class="el-icon-warning-outline"></i>
								<span> 如果总店还未注册，请先注册总店</span>
							</div>
							<div id="" style="margin-top: 16px;">
								<el-select class="serch-bar" v-loadMore='loadMore' v-model="chooseStore" value-key="Id"
									filterable remote reserve-keyword clearable="" placeholder="请输入客户名称"
									:remote-method="remoteMethod" :loading="loading" @clear="clear">
									<i class="el-icon-search el-input__icon" slot="prefix">
									</i>
									<el-option v-for="item in customers" :key="item.Id" :label="item.StoreName"
										:value="item">
									</el-option>
									<el-option v-if="loadMoreLoading" value="1">
										加载中...
									</el-option>
								</el-select>
							</div>
							<div class="serch-result" v-if="chooseStore.Id">
								<span class="title">门店信息</span>
								<div class="search-content">
									<el-row :gutter="10">
										<el-col :span="12"
											style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
											机构名称 <el-tooltip class="item" effect="dark" :content="chooseStore.StoreName"
												placement="top-start">
												<span>{{chooseStore.StoreName}}</span>
											</el-tooltip> 
										</el-col>
										<el-col :span="12"
											style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
											纳税人识别号：<el-tooltip class="item" effect="dark" :content="chooseStore.TaxNumber"
												placement="top-start">
												<span>{{chooseStore.TaxNumber}}</span>
												
											</el-tooltip>
											
										</el-col>
										<el-col :span="12">
											联系人姓名：{{chooseStore.LinkMan}}
										</el-col>
										<el-col :span="12">
											联系人电话：{{chooseStore.LinkTel}}
										</el-col>
										<el-col :span="24">
											门店地址：{{chooseStore.Address}}
										</el-col>
									</el-row>
								</div>
							</div>

							<div class="text-center" v-if="chooseStore.Id">

								<div id="" class="" style="margin-top: 30px;">
									<el-button :loading="comfirmLoading" type="primary"
										style="width: 100px;width: 136px;height: 40px;background: #0F6EEA;border-radius: 4px"
										@click='bindGeneralStoreBtn'>确定</el-button>
								</div>
							</div>
						</div>

					</div>
				</a-modal>
			</div>
		</template>
	</iMineTemplate>
</template>

<script>
	import {
		BaseMixin
	} from "@/mixins/BaseMixin";
	export default {
		mixins: [BaseMixin],
		name: "InterlockSettings",
		data() {
			return {
				pageTitle: ["我的账户", "连锁设置"],
				activedParentKey: 1,
				activedKey: 60,
				StoreName: "",
				show_bind: false,
				comfirmLoading: false,
				loading: false,
				loadMoreLoading: false,
				storeInfo: null,
				chooseStore: {},
				page: 1,
				total: 0,
				customers: [],
				urls: {
					GetHeadStoreList: "/api_customers/MutiCustomer/GetHeadStoreList",
					HeadStore: "/api_customers/MutiCustomer/GetHeadStore",
					BindUrl: "/api_customers/MutiCustomer/BindHeadStore"
				}
			};
		},
		mounted() {
			this.loadStore();
		},
		methods: {
			closeModel() {
				console.log('ini')
				this.show_bind = false
				this.clear()
			},
			clear() {
				this.customers = []
				this.chooseStore = {}
			},
			async loadMore() {
				console.log('inini')
				if (this.page * 10 >= this.total) {
					return
				}
				this.page++
				this.loadMoreLoading = true
				let data = await this.getAction(this.urls.GetHeadStoreList, {
					Name: this.StoreName,
					page: this.page,
					pageSize: 10
				})
				this.loadMoreLoading = false
				if (data.IsSuccess) {
					this.customers = this.customers.concat(data.Data)
				}
			},
			//获取所有门店信息
			async remoteMethod(query) {
				this.StoreName = query
				if (query !== '') {
					console.log('inini')
					this.loading = true;
					let data = await this.getAction(this.urls.GetHeadStoreList, {
						Name: query,
						page: 1,
						pageSize: 10
					})
					this.page = 1
					this.loading = false
					if (data.IsSuccess) {
						this.customers = data.Data
						this.total = data.Count
					}


				} else {
					this.customers = [];
				}
			},
			//绑定
			async bindGeneralStoreBtn() {
				this.comfirmLoading = true
				let res = await this.postAction(this.urls.BindUrl, {
					StoreId: this.chooseStore.Id
				})
				this.comfirmLoading = false
				if (res.Data && res.IsSuccess) {
					this.$toast({
						message: '绑定成功',
						duration: 1000,
						onClose: () => {
							this.show_bind = false
							this.loadStore()
							this.clear()
						},
					})
				} else {
					this.$toast({
						message: res.Msg || '添加失败，请重试',
						duration: 3200,
					})
				}
			},
			//加载店铺数据
			async loadStore() {
				var that = this;
				this.$hys.openLoading();
				let res = await this.getAction(this.urls.HeadStore);
				this.$hys.clearLoading();
				if (!res.IsSuccess) {
					this.$toast({
						position: "bottom",
						message: res.Msg
					});
					return;
				} else {
					if (res.Data && res.Data.Type == 1) {
						this.storeInfo = res.Data
					}
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	@import url("~@/styles/confirmOrder.less");

	.flex-invoice-box {
		height: 394px;

		.serch-result {
			margin-top: 24px;

			.title {
				height: 14px;
				border-left: 3px #0F6EEA solid;
				padding-left: 4px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #111A34;
			}

			.search-content {
				margin-top: 16px;
				width: 541px;
				height: 106px;
				background: rgba(15, 110, 234, 0.08);
				border-radius: 2px;
				border: 1px solid #0F6EEA;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #111A34;
				padding: 16px;

				.el-col {
					margin-bottom: 6px;
				}
			}
		}

		.bind-box {
			padding: 0 16px;

		}

		.no-tips {
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #0F6EEA;
			margin-top: 24px;
		}

		.flex-invoice-header {
			height: 44px;
			background: #EFEFEF;
			line-height: 44px;

			.image-close {
				width: 24px;
				height: 24px;
				position: absolute;
				right: 21px;
				top: 10px;
			}

		}
	}

	.interlock-settings {
		margin: 0 20px 20px 0;
		width: 940px;
		min-height: 706px;
		padding: 20px;
		font-size: 16px;
		background: rgba(255, 255, 255, 1);
		border-radius: 2px;
		border: 1px solid rgba(232, 232, 232, 1);
		// padding: 20px;
		position: relative;
		box-sizing: border-box;

		.sub-btn {
			width: 152px;
			height: 40px;
			background: #0F6EEA;
			border-radius: 4px;
			font-size: 16px;
			margin-top: 60px;
		}

		.content {
			text-align: left;
			width: 898px;
			// padding: 20px;
			font-weight: 400;
			line-height: 40px;
			box-sizing: border-box;

			.name {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #111A34;
			}

			.info {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #111A34;
			}
		}

		.no-store {
			.mian-word {
				margin-top: 10px;
				font-size: 14px;
				;
				font-weight: 500;
				color: #111A34;
			}

			.tips-box {
				border-bottom: 1px solid #E8E8E8;
				padding-bottom: 24px;
				margin-top: 16px;

				.tips-last {
					font-size: 14px;
					font-weight: 400;
					color: #111A34;
					margin-top: 24px;
				}
			}

			.example {
				margin-top: 24px;

				.example-title {
					font-size: 14px;
					font-weight: 400;
					color: #858B9C;
					margin-bottom: 24px;
				}
			}

			h5 {
				width: 509px;
				padding: 8px;
				background: linear-gradient(336deg, #FFFFFF 0%, #F0F3F5 100%);
				border-radius: 4px;
				font-size: 14px;
				font-weight: 400;
				color: #111A34;
			}
		}

		.title {
			width: 898px;
			height: 42px;
			border-bottom: 1px solid #e8e8e8;
			line-height: 22px;

			.danger_color {
				color: #FF3939;
				font-size: 12px;
				margin-left: 10px;
			}

			span {
				float: left;
				font-size: 18px;
				color: #222222;
			}
		}
	}
</style>
<style lang="less">
	.serch-bar {
		width: 300px;
		height: 34px;
		opacity: 0.9;

		.el-input__inner {
			background: #F0F3F5;
			border-radius: 17px;
			color: #111A34;
			line-height: 14px;
		}
	}
</style>
